import { render, staticRenderFns } from "./SystemAccountDetails.vue?vue&type=template&id=04cc3cfe&"
import script from "./SystemAccountDetails.vue?vue&type=script&lang=js&"
export * from "./SystemAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports